import { render, staticRenderFns } from "./zsyz-list.vue?vue&type=template&id=712b16df&scoped=true"
import script from "./zsyz-list.vue?vue&type=script&lang=js"
export * from "./zsyz-list.vue?vue&type=script&lang=js"
import style0 from "./zsyz-list.vue?vue&type=style&index=0&id=712b16df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712b16df",
  null
  
)

export default component.exports